module.exports = __webpack_public_path__ + "static/media/img-small-2@2x.6eefb8c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/img-small-2@2x.png
// module id = 72
// module chunks = 0